export let Loading = "loading/product";
export let Error = "loading/error";
export let GetFlashSalse = "Get/FlashSale";
export let GetTopDeals = "Get/TopDeals";
export let GetPickDeals = "Get/PickDeals";
export let GetFitFoods = "Get/FitFods";
export let GetWellnessProduct = "Get/wellness&personel";
export let GetworkoutEssential = "Get/workoutEssential";
export let GetpriceslashAlert = "Get/priceslashAlert";
